// extracted by css-extract-rspack-plugin
export default {"no-preview":"NoPreview_no-preview__dnRi2"};